// extracted by mini-css-extract-plugin
module.exports = {"root":"AdvancedFiltersMinReviewsDialog_root__XeDDU","changed":"AdvancedFiltersMinReviewsDialog_changed__K7RcW","reviewsMin":"AdvancedFiltersMinReviewsDialog_reviewsMin__NyPS6"};